import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const techStack = [
  "Python",
  "Machine Learning / AI",
  "Generative AI",
  "Google Cloud / AWS",
  "MLOps",
];

export function Footer() {
  const { t } = useTranslation()

  const navigation = [
    { name: t('nav.home'), href: '/' },
    { name: t('nav.profile'), href: '/profile' },
    { name: t('nav.blog'), href: '/blog' },
    { name: t('nav.tech'), href: '/tech' },
    { name: t('nav.editorialPolicy'), href: '/editorial-policy' },
    { name: t('nav.privacy'), href: '/privacy' },
  ]

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                T
              </div>
              <span className="font-semibold text-gray-900">Akasan</span>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex gap-3">
              <a href="https://github.com/Akasan" aria-label="GitHub" className="text-gray-500 hover:text-gray-700" target="_blank" rel="noopener noreferrer">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
              </a>
              <a href="https://x.com/akasan_ml" aria-label="X (Twitter)" className="text-gray-500 hover:text-gray-700" target="_blank" rel="noopener noreferrer">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/daisuke-akagawa-ab0759161" aria-label="LinkedIn" className="text-gray-500 hover:text-gray-700" target="_blank" rel="noopener noreferrer">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2">
              {navigation.map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-sm text-gray-600 hover:text-gray-900">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('footer.techStack')}</h3>
            <ul className="space-y-2">
              {techStack.map((item) => (
                <li key={item} className="text-sm text-gray-600">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('footer.contact')}</h3>
            <p className="text-sm text-gray-600 mb-4">
              {t('footer.contactDescription')}
            </p>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSegN-3lgUTM9cqmxCOw7nZnQA3BNhkFmwWQeg-a9d7sTZ97Qw/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              {t('footer.sendMessage')}
            </a>
          </div>
        </div>

        <div className="border-t border-gray-100 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-sm text-gray-500">{t('footer.copyright')}</p>
          <div className="flex gap-4 text-sm">
            <Link to="/editorial-policy" className="text-gray-500 hover:text-gray-900">{t('nav.editorialPolicy')}</Link>
            <Link to="/privacy" className="text-gray-500 hover:text-gray-900">{t('nav.privacy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
